import * as React from 'react';
import './index.css';
import { widget } from '../../charting_library';
import { UDFCompatibleDatafeed } from '../../chart-datafeed/udf-compatible-datafeed'
import { SaveLoad } from '../../chart-saveload/save_load'
import { BrokerApi } from '../../chart-brokerapi/broker'
import { ChartBuySell } from '../ChartBuySell/index'
import { ChartWatchlists } from '../../chart-watchlists/index'
import { layoutSubServices } from "../../sub";
import { remoteConfigGetter } from "../../utils/remoteConfig";
import { messaging } from "../../utils/remoteConfig";
import { getToken, isSupported } from "firebase/messaging";
import { alertsListModel, HandleBasketModel, optionStrategyModel } from "../common/handleSocket";
import { setLogging, setLoggingCC } from '../../utils/helpers';
import { getChartTheme } from "../DashBoard/WalkThrough"
import { applyInterfaceTheme, getActiveTheme, getStoredTheme, layoutNeedsRepaint, normalizeTheme, setStoredTheme, writeLayoutSignature } from "../../utils/theme";
import { IndicatorPack } from "../../chart-datafeed/udf-compatible-datafeed-base";
import { subscribeToActiveChartSymbol } from "./activeSymbol";
import { installMultiChartLayoutHandling } from "./multiChartLayout";
import { keepChartServerTimeLive } from "./liveServerTime";
import { createChartBootWatchdog } from "./vendor/chart-boot-watchdog";
import { watchOiStudies } from "../../chart-datafeed/vendor/oi-studies";
import { reloadChartBars } from "../../chart-datafeed/streaming_provider";
import { chartLog } from "../../services/otel/consoleLogger";
import {
	getAddFundsIcon,
	getBasketIcon,
	getChangeTheamIcon,
	getLogOutIcon,
	getUerSettingIcon,
	getOptionStrategyIcon,
	getFeedbackIcon,
	getAlertsIcon,
	getRupeezyIcon
} from "../../common/iconMaker";
import { API_URL, DOCK_BASE_URL, VORTEX_URL_V2 } from "../../utils/config";
import { t } from '../../utils/appString';
import { analytics } from "../../analytics/trackingPlan";
import * as tp from "@asthabhopal/tracking-plan";

function createDeferredPromise() {
	var resolveFn;
	var rejectFn;

	var promise = new Promise(function (resolve, reject) {
		resolveFn = resolve;
		rejectFn = reject;
	});

	return {
		promise: promise,
		reject: rejectFn,
		resolve: resolveFn,
	};
}

var orderResult = createDeferredPromise();
var positionResult = createDeferredPromise();
var optionChainDialog = createDeferredPromise();

var customOrderDialog = null;
var customPositionDialog = null;
var optionChainDialog = null;


var onOrderResultCallback = function (result) {
	orderResult.resolve(result);
	if (customOrderDialog !== null) {
		customOrderDialog.style.visibility = 'hidden';
		customOrderDialog.removeAttribute('data-symbol');
	}
};

var onPositionResultCallback = function (result) {
	positionResult.resolve(result);
	if (customPositionDialog !== null) {
		customPositionDialog.style.display = 'none';
		customPositionDialog.removeAttribute('data-symbol');
	}
};

var onOptionChainResultCallback = function (result) {
	onOptionChainResultCallback.resolve(result);
	if (optionChainDialog !== null) {
		optionChainDialog.style.visibility = 'hidden';
	}
}


window.isAuthenticated = true
deleteLocalWatchlists();

function deleteLocalWatchlists() {
	for (var i in localStorage) {
		if (localStorage.hasOwnProperty(i)) {
			if (i.match('tradingview.savedwatch')) {
				localStorage.removeItem(i)
			}
		}
	}
}

function clearSessionStorage(keyPattern) {
	for (let i in sessionStorage) {
		if (sessionStorage.hasOwnProperty(i)) {
			if (i.match(keyPattern)) {
				sessionStorage.removeItem(i);
			}
		}
	}
}

export class TVChartContainer extends React.PureComponent {

	tvWidget = null;

	auth_token = null
	ssoToken = null
	datafeed = null
	user_id = null

	lsubscription = undefined;



	constructor(props) {
		super(props);
		this.auth_token = this.props.data.access_token;
		this.ssoToken = this.props.data.ssoToken;
		this.user_id = this.props.data.user_id;
		this.logout_function = this.props.logoutFunction;
		this.option_chain_function = this.props.OpenOptionModel;
		this.new_option_chain_function = this.props.OpenNewOptionModel;
		this.new_ggt_function = this.props.OpenNewGGTModel;
		this.open_future_chain_function = this.props.OpenFutureModel;
		// Use the module-load snapshots, NOT a fresh remoteConfigGetter call. This
		// constructor runs after login and routing, by which point Remote Config may
		// have activated a different value than every other service in the app read
		// at import time — which is exactly how the chart ended up calling a
		// different API host than the rest of the page. See utils/config.ts.
		this.inhouseUrl = VORTEX_URL_V2
		// this.inhouseUrl = "http://localhost:5100/"
		this.datafeed = new UDFCompatibleDatafeed(API_URL, this.auth_token, this.inhouseUrl, this.logout_function)
		this.brokerClass = null
		this.user_profile = this.props.data

		this.state = { renderBuySell: false }
		this.ref = React.createRef();
		this.odinUrl = ""
		this.ocToken = this.props.data.others.ocToken
	}
	// CreateOrderDialogContext = React.createContext(this.createOrderDialog);

	componentDidMount = () => {
		document.addEventListener('freeze', (event) => {
			// logMessage("page is about to be frozen")
			this.brokerClass.socket_disconnect()
			this.datafeed.closeFeedTemporarily();
		});

		document.addEventListener('resume', (event) => {
			// logMessage("frozen page resumed")
			this.brokerClass.socket_initialize();
			this.datafeed.connectFeed(this.ocToken, this.user_id);
		});
		var logging = (process.env.REACT_APP_LOGGING != "false")
		var createOrderDialogFunc = this.createOrderDialog
		this.datafeed.connectFeed(this.ocToken, this.user_id);
		setLogging(logging)
		setLoggingCC(this.props.data.user_id)
		// Snapshot whether this browser already has a theme BEFORE creating the
		// widget, since the charting library writes the theme key to localStorage
		// during init. This drives the first-visit-only server bootstrap below.
		const themeWasStoredBeforeInit = getStoredTheme() !== null;
		// The symbol the chart falls back to when a saved layout has none (and the
		// last-resort repair target for a corrupt one). Named because the CAS session
		// prewarm below and the SaveLoad adapter MUST agree on it.
		const CHART_FALLBACK_SYMBOL = 'NSE:NIFTYIDX';
		// Lock the user's current theme into our OWN key before the widget exists.
		// The charting library force-flushes the chart's theme into its key (and a
		// stale layout load can clobber it back to light), so we must capture the
		// intended value now and treat our key as the source of truth from here on.
		setStoredTheme(getActiveTheme());
		const widgetOptions = {
			custom_css_url: 'css/style.css',
			theme: getActiveTheme(),
			custom_font_family: "HK Grotesk",
			fullscreen: true,
			debug: false, // uncomment this line to see Library errors and warnings in the console
			// symbol: 'NSE:BANKNIFTY-EQ',
			// interval: (getParameterByName('interval') || '15'),
			timezone: "Asia/Kolkata",
			container: this.ref.current,
			// NOTE: `timeframe` is the visible DATE RANGE, not the resolution. Forcing it
			// (e.g. '1D') shows ~1 day — which on a 1D-resolution chart is ~1 candle
			// (over-zoomed), and fights the saved layout's viewport on reopen (a 1m→1d→1m
			// flash). The initial fetch is already bounded by the countback cap, so leave
			// this unset and let the saved layout / TV default decide the view.
			// timeframe: '1D',
			datafeed: this.datafeed,
			library_path: "../tvTerminal/charting_library/",
			locale: 'en',
			allow_symbol_change: true,
			// disabled_features: [],
			// `skip_event_target_check` is the BACKSTOP for the chart-type dropdown going
			// dead after you pick a style: ToolWidgetMenu swallows any click whose
			// `event.target` fails `instanceof Node`, and a re-parsed header icon <svg> is
			// born carrying the PARENT window's prototypes instead of the chart iframe's.
			// The actual fix is the `pointer-events: none` rule in
			// charting_library/css/style.css (see the comment there) — it keeps
			// `event.target` on the button, which also preserves click-to-CLOSE. This flag
			// alone does NOT: PopupMenu's outside-click exemption applies the same check
			// ungated, so the menu closes on mousedown and reopens on click (open-only).
			// Keep it only as a hedge in case that selector ever stops matching.
			// v32 parity: 'allow_arbitrary_symbol_search_input' restores pre-v28 Symbol Search
			// behavior (Enter resolves whatever was typed, even without a search match).
			// pre_post_market_price_line: draws the pre-open / CAS price as a
			// dotted line plus a price-scale label, fed from the quote stream's
			// current_session + rtc (see extendedQuoteFields in
			// chart-datafeed/streaming_provider.ts). Without this featureset the
			// library never builds that source and those fields are inert.
			enabled_features: ['skip_event_target_check', 'tick_resolution', 'seconds_resolution', 'dom_widget', 'hotlists', 'study_templates', 'header_compare', 'move_logo_to_main_pane', 'show_symbol_logos', 'show_symbol_logo_in_legend', 'show_symbol_logo_in_account_manager', 'show_exchange_logos', 'custom_resolutions', 'allow_arbitrary_symbol_search_input', 'pre_post_market_price_line', 'pre_post_market_sessions'],
			// v32 parity: watchlist_cross_tab_sync off (v29.2 turned it on by default),
			// long_press_floating_tooltip off (v30 added a long-press OHLCV tooltip on touch).
			disabled_features: ['order_panel', 'watchlist_cross_tab_sync', 'long_press_floating_tooltip'],
			// enabled_features: [''],
			charts_storage_url: 'https://saveload.tradingview.com',
			hide_symbol_toolbar: true,
			charts_storage_api_version: "1.1",
			client_id: 'rupeezy.in',
			user_id: this.user_id,
			hotlists: true,
			calendar: true,
			details: true,
			symbol_search_request_delay: 1000,
			load_last_chart: true,
			auto_save_delay: 5,
			// Registered study set MUST match mobile_charts — both surfaces share
			// one saved-layout store and the library silently drops a saved study
			// whose id it doesn't know. See chart-datafeed/vendor/indicators.
			custom_indicators_getter: function (PineJS) {
				if (!IndicatorPack) {
					console.warn('[chart] custom_indicators_getter called before the datafeed was constructed');
					return Promise.resolve([]);
				}
				return IndicatorPack.getIndicatorTemplates(PineJS)
			},
			widgetbar: {
				details: true,
				news: true,
				watchlist: true,
				datawindow: true,
				watchlist_settings: {
					default_symbols: []
				}
			},
			// datafeed.getNews(symbol,callback)
			news_provider: (symbol, callback) => {
				this.datafeed.getNews(symbol, callback)
			},
			// rss_news_feed: {
			//     "default": [ {
			//         url: "http://localhost:5100/news?symbol={SYMBOL}",\
			//         name: "Yahoo Finance"
			//     } ]
			// },
			broker_factory: (host) => {
				this.brokerClass = window.brokerClass = new BrokerApi(host, this.datafeed, process.env.REACT_APP_VORTEX_URL, this.auth_token, this.inhouseUrl, this.user_profile, () => { });
				// customOrderDialog = window.customOrderDialogue = createOrderDialog(brokerClass, onOrderResultCallback, datafeed);
				// optionChainDialog = window.optionChainDialog = createOptionChainDialog(brokerClass,onOptionChainResultCallback,datafeed); 
				// $( "#custom-order-dialog-id" ).draggable();
				// customPositionDialog = window.customPositionDialogue  = createPositionDialog(brokerClass, onPositionResultCallback,datafeed);
				return brokerClass;
			},
			broker_config: {
				configFlags: {
					supportBottomWidget: true,
					// v32: ordersHistory() is not implemented in our BrokerApi; from v30 the
					// library defaults supportOrdersHistory to true and renders a History tab
					// that would break without it — keep it explicitly off.
					supportOrdersHistory: false,
					// v32 parity: v31 added supportAdaptiveLayout (default true) which hides
					// TP/SL & P&L buttons on order/position lines on narrow screens; keep the
					// pre-v31 always-visible behavior.
					supportAdaptiveLayout: false,
					// supportNativeReversePosition: true,
					// supportReducePosition: true,
					supportClosePosition: true,
					supportPLUpdate: false,
					supportLevel2Data: true,
					// showQuantityInsteadOfAmount: true,
					supportEditAmount: true,
					supportPartialClosePosition: true,
					supportModifyOrderPrice: true,
					supportMargin: true,
					supportReversePosition: true,
					supportNativeReversePosition: true
				},
				durations: [
					{ name: 'DAY', value: 'DAY', supportedOrderTypes: [1, 2, 3, 4] },
					{ name: 'IOC', value: 'IOC' },
				],

				customUI: {

					showOrderDialog: function (order, focus) {
						ChartBuySell.instance?.ShowOrderDialog(order, onOrderResultCallback);
						return orderResult.promise;
					},
					// showPositionDialog: function(position, brackets, focus) {
					// 	BuySellWIndowInstance.ShowOrderDialog(position);
					// 	// NOTE: This promise should be resolved with true/false only
					// 	return positionResult.promise;
					// },
					// showClosePositionDialog: function(position, focus) {
					// 	BuySellWIndowInstance.ShowOrderDialog(position);
					// 	// NOTE: This promise should be resolved with true/false only
					// 	return positionResult.promise;
					// }

				},
			},
			// 3rd arg = last-resort fallback symbol for repairing corrupt saved layouts
			// (empty/"-" symbol) that can't be recovered from their own data. The TV
			// terminal boots via load_last_chart with no per-open symbol, so we default
			// to NIFTY (mirrors the webapp's iframe fallback) to avoid a stuck spinner.
			// 4th arg: as soon as the saved layout's content arrives, start resolving
			// its symbol — the datafeed's in-flight dedup turns the library's own
			// resolve (fired ~100ms later, after layout parsing) into a piggyback.
			// Adapter is hoisted (this.saveLoadAdapter) so the container can ask it
			// WHICH layout the library's load_last_chart boot applied — we no longer
			// re-load the last layout manually, which used to double every boot fetch
			// (chartsList, chart content, history).
			save_load_adapter: (this.saveLoadAdapter = new SaveLoad(this.inhouseUrl, this.auth_token, CHART_FALLBACK_SYMBOL, (layoutSymbol) => {
				try {
					// Warm the restored layout symbol's session, then resolve it ~100ms
					// before the library fires its own (deduped) resolve — so by the time
					// the bounded wait starts, the fetch is already on the wire.
					this.datafeed.prewarmSession(layoutSymbol);
					const p = this.datafeed.resolveSymbol(layoutSymbol, () => { }, () => { }, '');
					if (p && typeof p.catch === 'function') { p.catch(() => { }); }
				} catch (e) { /* best-effort prime */ }
			}, () => {
				// 5th arg: fired after EVERY successful save (autosave, repaint
				// persist, manual Ctrl+S/menu). Refresh the layout signature at
				// this single choke point so no save path can leave it stale
				// (a stale signature costs a repaint+save on the next boot).
				// recordSignatureFromServer is defined later in componentDidMount;
				// saves only happen long after mount, so the reference is safe.
				try { recordSignatureFromServer(getActiveTheme()) } catch (e) { /* best-effort */ }
			}, (level, event, attrs) => {
				// 6th arg: domain-log sink. The adapter keeps its span events for Tempo
				// and mirrors the boot-relevant ones to Loki through this, so one
				// dashboard covers both products. It de-duplicates per session.
				chartLog(level, event, attrs);
			})),

		};

		// Put the boot symbol's session on the wire before the widget even exists, so
		// the bounded wait in the first resolve is normally already satisfied.
		try { this.datafeed.prewarmSession(CHART_FALLBACK_SYMBOL); } catch (e) { /* best-effort */ }

		// ----- boot watchdog ---------------------------------------------------
		// A slow boot is logged, never interrupted — recovery requires an error
		// actually observed while restoring the layout.
		//
		// Unlike mobile_charts this does NOT reload: flow-web is the whole trading
		// app, and reloading it under the user because one drawing failed to restore
		// is worse than the failure. The layout is marked for drawings-safe mode
		// instead, so the chart comes back working on the user's own next reload.
		try {
			const recoverId = sessionStorage.getItem('chart.recover.layoutId');
			if (recoverId) { window.__chartDrawingsSafeMode = recoverId; }
		} catch (e) { /* private mode */ }
		this.chartBootWatchdog = createChartBootWatchdog({
			timeoutMs: 20000,
			log: (level, event, attrs) => chartLog(level, event, attrs),
			store: (typeof sessionStorage !== 'undefined') ? sessionStorage : null,
			recover: (layoutId) => {
				try { sessionStorage.setItem('chart.recover.layoutId', String(layoutId)); } catch (e) { /* private mode */ }
			},
		});
		window.__chartBootWatchdog = this.chartBootWatchdog;

		const tvWidgetChart = new widget(widgetOptions);
		// NOTE (v32): TV removed the sidebar DOM entry and ships no public API to
		// open the panel — host.domPanelVisibility() is a read-only MIRROR of the
		// trading panel's page state (setValue() flips it without rendering), and
		// no ChartActionId exists. The real trigger is the internal trading
		// controller: host._trading.setDOMPanelVisibility(v) — the exact function
		// v32 binds to Shift+D and to the global-search "Open DOM widget" entry
		// (verified live 2026-07-20; see the DOM header button in headerReady).
		// Private API: guarded, and Shift+D remains as the native fallback.
		this.tvWidget = tvWidgetChart;
		window.tvWidget = tvWidgetChart
		var logout_function = this.logout_function
		var optionModel = this.option_chain_function
		var newOptionModel = this.new_option_chain_function
		var newGGTModel = this.new_ggt_function
		var futureChainModel = this.open_future_chain_function

		var datafeed = this.datafeed
		tvWidgetChart.subscribe('onAutoSaveNeeded', (_) => {
			// Signature refresh happens in the adapter's onSaved hook (fires for
			// every save path) — no per-caller callback needed here.
			//
			// The error callback is required, not decorative: the adapter now REJECTS
			// a save it deliberately skipped (a transient empty symbol), which is what
			// keeps the chart dirty so the next autosave retries. Without a handler
			// that rejection surfaced as an unhandled promise rejection in the console.
			// No-arg is the v32 signature; passing callbacks selects the DEPRECATED
			// overload, whose console.warn our own capture ships to Loki. The catch is
			// still required — the adapter REJECTS a save it deliberately skipped (a
			// transient empty symbol), which keeps the chart dirty so the next one retries.
			Promise.resolve(tvWidgetChart.saveChartToServer())
				.catch(() => { /* adapter logged it; next autosave retries */ })
		})
		function OpenBasketModel() {
			HandleBasketModel(true)
		}

		function OpenOptionStrategy() {
			optionStrategyModel(true)
		}

		function openAlertsForm() {
			alertsListModel(true)
		}

		function openFeedbackForm() {
			window.open('https://forms.gle/erJD5a6GNQL8JqiV7', '_blank');
		}

		function openMenuCallBack(key) {
			optionModel(key)
		}
		function callNewOptionChain(key) {
			newOptionModel(key)
		}

		function callNewGGT(key) {
			newGGTModel(key)
		}

		function callFutureChain(key) {
			futureChainModel(key)
		}

		function AddThemeClassToBodyReact(name) {
			if (!name) return;
			const theme = normalizeTheme(name);
			getChartTheme(theme) // keep the walkthrough tooltip styling in sync
			applyInterfaceTheme(theme)
		}

		// TvTerminal shares ONE server-side layout with the webapp's chart, and the library
		// bakes theme COLORS into it. A layout re-saved by the other surface restores
		// mismatched colors that getTheme()/changeTheme can't detect or repaint. So we drive
		// repaints off a signature of the layout we last painted (see utils/theme): force a
		// repaint only when the loaded layout or our theme changed, then persist + re-record.

		// Loaded layout record, set right before loadChartFromServer.
		let loadedRecord = { id: '', modified: null };
		let repaintInFlight = false;
		// {id, modified} for a record. The in-house adapter returns raw DB rows whose
		// freshness field is `timestamp` (epoch ms, bumped on save); `modified_iso` is the
		// built-in REST fallback. This is the signal that reveals the other surface's save.
		const toRecordRef = (record) => ({
			id: record && record.id != null ? String(record.id) : '',
			modified: record && typeof record.timestamp === 'number' ? record.timestamp
				: (record && typeof record.modified_iso === 'number' ? record.modified_iso : null),
		});
		// After a save, refresh the signature with the new stamp so our own save
		// doesn't look "foreign" next load. The save/load adapter remembers the
		// saved row from the save RESPONSE — no chartsList re-fetch needed. The
		// old getSavedCharts round trip remains only as a fallback.
		const recordSignatureFromServer = (theme) => {
			try {
				const saved = this.saveLoadAdapter && this.saveLoadAdapter.getLastSavedRecord && this.saveLoadAdapter.getLastSavedRecord();
				if (saved && saved.id) {
					loadedRecord = { id: saved.id, modified: saved.timestamp };
					writeLayoutSignature({ id: loadedRecord.id, modified: loadedRecord.modified, theme });
					return;
				}
				tvWidgetChart.getSavedCharts((records) => {
					const rec = records && records.length ? records[records.length - 1] : null;
					const ref = rec ? toRecordRef(rec) : loadedRecord;
					loadedRecord = ref;
					writeLayoutSignature({ id: ref.id, modified: ref.modified, theme });
				});
			} catch (e) { /* best-effort */ }
		};
		const persistChartLayout = (theme) => {
			try {
				// Signature refresh rides the adapter's onSaved hook.
				Promise.resolve(tvWidgetChart.saveChartToServer())
					.catch(() => { /* keep stale; next load repaints */ });
			} catch (e) { /* saving is best-effort */ }
		};
		// `allowForce` only on a real layout load (chart_loaded); the onChartReady pass
		// runs before loadChartFromServer, so forcing there would be undone by that load.
		const reconcileTheme = (allowForce) => {
			const desired = getActiveTheme();
			const chartTheme = normalizeTheme(tvWidgetChart.getTheme());
			AddThemeClassToBodyReact(desired);

			// Align the theme NAME (repaints a fresh widget whose layout hasn't loaded).
			if (chartTheme !== desired) {
				tvWidgetChart.changeTheme(desired, { disableUndo: true });
			}

			if (!allowForce || repaintInFlight) return;

			if (layoutNeedsRepaint(loadedRecord, desired)) {
				repaintInFlight = true;
				const other = desired === 'dark' ? 'light' : 'dark';
				// Flip then restore to force a repaint (changeTheme no-ops when the name
				// already matches). The flip matches the shown colors, so no extra flicker.
				Promise.resolve(tvWidgetChart.changeTheme(other, { disableUndo: true }))
					.then(() => tvWidgetChart.changeTheme(desired, { disableUndo: true }))
					.then(() => {
						// Record + persist so the layout carries our colors and the next reload no-ops.
						writeLayoutSignature({ id: loadedRecord.id, modified: loadedRecord.modified, theme: desired });
						persistChartLayout(desired);
					})
					.finally(() => { repaintInFlight = false; });
			} else {
				// Already correct — keep the signature current for this load.
				writeLayoutSignature({ id: loadedRecord.id, modified: loadedRecord.modified, theme: desired });
			}
		};

		tvWidgetChart.onChartReady(() => {
			// Close the deadline FIRST, so a slow-but-successful boot is never reported
			// as a failure. Nothing is logged on success — Loki carries problems only,
			// and the boot count is already in Tempo.
			try {
				this.chartBootWatchdog && this.chartBootWatchdog.chartReady();
			} catch (e) { /* telemetry must never break the chart */ }
			// Unfreeze the chart clock before anything else reads it (see
			// liveServerTime.ts): without this the bar-close countdown paints once
			// and then stops.
			keepChartServerTimeLive(this.ref.current);
			this.brokerClass.socket_initialize();

			// OI Profile draws on a canvas pinned to the pane's right edge,
			// because a custom study cannot emit the hhists graphic a
			// horizontal histogram needs, and study plots live in bar-index
			// space so they cannot stay pinned to the price axis. The STUDY
			// still owns the Indicators-dialog entry, its settings and
			// saved-layout persistence; this only starts the renderer.
			//
			// The same call also styles the Rupeezy badge in the Indicators
			// dialog and installs the duplicate-study guard — all three need a
			// live widget and none can be expressed in study metainfo.
			//
			// Every study works without this. Skipping it renders the profile
			// blank, leaves the badge as plain text and lets a study be added
			// twice, rather than breaking anything.
			try {
				if (IndicatorPack) {
					IndicatorPack.attachToChart({
						widget: tvWidgetChart,
						getContainer: () => this.ref.current,
					});
				}
			} catch (e) {
				console.warn('[chart] chart-indicators failed to attach', e);
			}
			// Ask /data/history for the open-interest column only while a study
			// that reads it is on the layout. Watches studies, saved layouts and
			// layout size changes, and refetches on the rising edge — bars
			// already fetched without the column cannot grow one, and no study
			// recompute can conjure it.
			try {
				this.oiWatcher = watchOiStudies({
					widget: tvWidgetChart,
					log: (level, event, attrs) => chartLog(level, event, attrs),
					onChange: (wanted) => {
						this.datafeed.setOiWanted(wanted);
						// One line per transition, not per request: this is how
						// you tell whether demand-driven OI is firing in the
						// field, and how often a chart pays the refetch.
						chartLog('info', 'chart.oi.demand', { wanted });
						if (!wanted) {
							// Nothing left to read what is already loaded, so
							// later pages simply stop asking. Spending a
							// layout-wide refetch to REMOVE a column costs the
							// user a visible reload for no gain.
							return;
						}
						// FORCED. reloadChartBars throttles unforced calls to one
						// per 3s and its other callers are storms (foreground,
						// online, socket reopen). Adding a study inside that
						// window would have its one refetch swallowed, and
						// nothing would retry — the flag is already true — so
						// the study would stay blank for the session.
						reloadChartBars('oi_study', true);
					},
				});
				this.oiWatcher.start();
			} catch (e) {
				console.warn('[chart] OI study watcher failed to start', e);
			}
			// Keep the session cache warm for whatever the chart is showing. Every
			// cash-equity resolve looks its session up regardless (TV caches resolved
			// symbols for the life of the page, so the first resolve is the only one we
			// are ever asked for) — these calls only make sure the answer is usually
			// already in hand when that resolve happens.
			try {
				const boot = tvWidgetChart.activeChart().symbol();
				if (boot) this.datafeed.prewarmSession(boot);
				tvWidgetChart.activeChart().onSymbolChanged().subscribe(null, () => {
					try {
						const s = tvWidgetChart.activeChart().symbol();
						if (s) this.datafeed.prewarmSession(s);
					} catch (e) { /* best-effort */ }
				});
			} catch (e) { /* best-effort */ }
			// Re-fit ONLY a layout that SaveLoad just repaired (faulty-JSON): its saved
			// viewport + price range are untrustworthy, so snap the time scale and turn
			// price auto-scale back on once its data lands. NORMAL saved layouts are left
			// completely alone — we do NOT force a timeScaleReset on every load, since that
			// overrode the user's saved zoom and caused a viewport flash on reopen.
			try {
				tvWidgetChart.activeChart().onDataLoaded().subscribe(null, () => {
					if (!window.__chartLayoutRepaired) return;
					window.__chartLayoutRepaired = false;
					try { tvWidgetChart.activeChart().executeActionById('timeScaleReset'); } catch (e) { }
					try {
						tvWidgetChart.activeChart().getPanes().forEach((pane) => {
							const ps = pane && pane.getMainSourcePriceScale && pane.getMainSourcePriceScale();
							if (ps && typeof ps.setAutoScale === 'function') { ps.setAutoScale(true); }
						});
					} catch (e) { }
				});
			} catch (e) { }
			// Pull the loaded-layout record from the save/load adapter (set when the
			// library's own load_last_chart boot fetched the content). Replaces the
			// old manual getSavedCharts + loadChartFromServer pass in headerReady,
			// which re-loaded the layout the library had ALREADY loaded — doubling
			// chartsList, chart-content and history requests on every boot.
			// DELIBERATELY INLINED at each call site (no shared helper): two pre_prod
			// deploys shipped a merge state that dropped a shared helper's definition
			// while keeping its calls → ReferenceError inside widgetReady → all custom
			// header UI + watchlist dead. Inline copies survive ANY partial merge.
			{
				const rec0 = this.saveLoadAdapter && this.saveLoadAdapter.getLastLoadedRecord();
				if (rec0) { loadedRecord = { id: rec0.id, modified: rec0.timestamp }; }
			}
			// Apply our theme now, and re-apply on every layout load (stale colors).
			reconcileTheme(false);
			tvWidgetChart.subscribe('chart_loaded', () => {
				const rec1 = this.saveLoadAdapter && this.saveLoadAdapter.getLastLoadedRecord();
				if (rec1) { loadedRecord = { id: rec1.id, modified: rec1.timestamp }; }
				reconcileTheme(true);
				// #3: auto-close the "Load layout" dialog once a layout has been
				// applied. TV leaves the dialog open after a pick (so you can eyeball
				// several), but the user wants it dismissed on select. chart_loaded
				// only fires on an actual layout load — the boot load has no dialog
				// open, so this is a harmless no-op there.
				try { tvWidgetChart.closePopupsAndDialogs(); } catch (e) { /* best-effort */ }
			});
			// Safety net: if the initial content fetch was still in flight during
			// onChartReady and no chart_loaded fired for the built-in initial load,
			// run one forced reconcile on the first data paint so a stale-colored
			// saved layout still gets repainted (idempotent — the signature check
			// no-ops when a chart_loaded pass already handled it).
			let initialThemeReconciled = false;
			try {
				tvWidgetChart.activeChart().onDataLoaded().subscribe(null, () => {
					if (initialThemeReconciled) return;
					initialThemeReconciled = true;
					const rec2 = this.saveLoadAdapter && this.saveLoadAdapter.getLastLoadedRecord();
					if (rec2) {
						loadedRecord = { id: rec2.id, modified: rec2.timestamp };
						reconcileTheme(true);
					}
				});
			} catch (e) { }
			subscribeToActiveChartSymbol(tvWidgetChart, this.datafeed);
			tvWidgetChart.subscribe('activeChartChanged', (index) => {
				subscribeToActiveChartSymbol(tvWidgetChart, this.datafeed);
			});
			// Multiple-chart layout: backfill charts a bigger layout reveals (they
			// may have been hidden through a network gap). See multiChartLayout.ts.
			try { this.teardownLayoutHandling = installMultiChartLayoutHandling(tvWidgetChart); } catch (e) { /* best-effort */ }
			tvWidgetChart.headerReady().then(() => {
				// NOTE: the last saved layout is loaded ONCE by the library itself
				// (load_last_chart: true, via the save/load adapter). The manual
				// getSavedCharts + loadChartFromServer pass that used to live here
				// re-loaded that same layout a second time — doubling chartsList,
				// chart-content and history on every boot. loadedRecord now comes
				// from this.saveLoadAdapter.getLastLoadedRecord() (see onChartReady).
				// HARDENING: every step below runs inside ONE headerReady callback —
				// a single uncaught throw here wipes ALL custom header UI (logo,
				// funds/theme/basket/alerts buttons). Each independent step is
				// isolated so one failure cannot cascade into the rest.

				// Only bootstrap from the server on the first visit on this browser
				// (no locally stored theme). On every later load the chart restores
				// its theme from localStorage, so we must NOT override it here — doing
				// so unconditionally caused the reload race (stale server value) and
				// the post-paint flicker.
				if (!themeWasStoredBeforeInit) {
					try {
						this.brokerClass?._getPreferences().then((response) => {
							const serverTheme = normalizeTheme(response?.chartTheme)
							setStoredTheme(serverTheme)
							AddThemeClassToBodyReact(serverTheme)
							// Apply the server theme to the chart and persist it into the
							// layout, so subsequent reloads load the right colors instead of
							// the saved layout's original (possibly mismatched) ones.
							Promise.resolve(tvWidgetChart.changeTheme(serverTheme, { disableUndo: true }))
								.then(() => persistChartLayout(serverTheme))
						}).catch(() => { })
					} catch (e) { console.error('first-visit theme bootstrap failed', e) }
				}
				try {
				if (isSupported() && messaging != null && Notification.permission != 'denied') {
					Notification.requestPermission().then(async (permission) => {
						try {
							const token = await getToken(messaging, { vapidKey: remoteConfigGetter("vapidkey").asString() })
							if (token) {
								this.brokerClass.subscribeFcmByToken(token)
								return token;

							}
							else {
								console.log('No Instance ID token available. Request permission to generate one.');
							}
						} catch (error) {
							const token = await getToken(messaging, { vapidKey: remoteConfigGetter("vapidkey").asString() })
							if (token) {
								this.brokerClass.subscribeFcmByToken(token)
								return token;
							}
							else {
								console.log('No Instance ID token available. Request permission to generate one.');
							}
						}

					}).catch((permission) => {
						console.log(permission)
					})
				}
				} catch (e) { console.error('notification permission setup failed', e) }
				var button0 = tvWidgetChart.createButton();
				button0.setAttribute("title", "Rupeezy");
				button0.setAttribute("id", "Rupeezy");
				button0.style.pointerEvents = "all";
				button0.style.display = "flex";
				button0.style.alignItems = "center";
				button0.style.padding = "0 6px";
				// closest() can return null if the library's internal header group
				// class ever changes — must not take down the rest of the header.
				try { button0.closest('.group-MBOVGQRI').style.order = -2; } catch (e) { }  // will move logo to extreme left
				button0.appendChild(getRupeezyIcon());

				var button1 = tvWidgetChart.createButton();
				button1.setAttribute('title', 'Add Funds');
				button1.setAttribute('id', 'add_funds')
				button1.addEventListener('click', () => {
					analytics.elementInteraction({ flow: tp.Flow.FUNDS, screen: tp.Screen.CHART, element: tp.Element.ADD_FUND, action: tp.Action.TAPPED });
					let doc_url_pay_in = `${DOCK_BASE_URL}dashboard?path=pay-in&sso_auth_token=${this.ssoToken}&version=v2`
					window.open(doc_url_pay_in, '_blank').focus()
				});
				// button1.textContent = 'Add Funds';
				button1.appendChild(getAddFundsIcon())
				button1.style.pointerEvents = 'all'

				var button2 = tvWidgetChart.createButton();
				button2.setAttribute('title', 'Manage Account');
				button2.setAttribute('id', 'manage_account')
				button2.addEventListener('click', () => {
					analytics.elementInteraction({ flow: tp.Flow.ACCOUNT, screen: tp.Screen.CHART, element: tp.Element.VIEW_PROFILE, action: tp.Action.TAPPED, label: "manage_account" });
					let doc_url_profile = `${DOCK_BASE_URL}dashboard?path=profile&sso_auth_token=${this.ssoToken}&version=v2`
					window.open(doc_url_profile, '_blank').focus()
				});
				// button2.textContent = 'Manage Account';
				button2.appendChild(getUerSettingIcon())
				button2.style.pointerEvents = 'all'

				// var referBtn = tvWidget.createButton();
				// referBtn.setAttribute('title', 'Refer & earn 20% brokerage share');
				// referBtn.setAttribute('id','refer_earn')
				// referBtn.addEventListener('click', () => { window.GtmPusher({
				// 	event: 'tv-refer-link-clicked'
				// })
				// let doc_url_profile = `${DOCK_BASE_URL}dashboard?path=profile/refer-earn-brokerage&sso_auth_token=${this.ssoToken}&version=v2`
				// window.open(doc_url_profile, '_blank').focus() });
				// // button2.textContent = 'Manage Account';
				// referBtn.appendChild(getReferEarnIcon())
				// referBtn.style.pointerEvents = 'all'

				var button3 = tvWidgetChart.createButton();
				button3.setAttribute('title', 'Change Theme');
				button3.setAttribute('id', 'change_theme')
				button3.addEventListener('click', function () {
					// Base the toggle on our stored source of truth, not the chart's
					// possibly-divergent current theme.
					var current = getActiveTheme()
					var next = current === 'light' ? 'dark' : 'light'

					// Switch our key + interface now. We leave the signature untouched: if a
					// reload beats the save, its theme differs from `next` and the load repaints.
					setStoredTheme(next)
					AddThemeClassToBodyReact(next)

					// UNDOABLE change (NO disableUndo) so the library auto-saves it; then force
					// an immediate save and record the new signature for flicker-free reloads.
					Promise.resolve(tvWidgetChart.changeTheme(next)).then(function () {
						try {
							Promise.resolve(tvWidgetChart.saveChartToServer())
								.then(function () { recordSignatureFromServer(next) })
								.catch(function () { /* keep stale; reload will force-repaint */ })
						} catch (e) { /* saving is best-effort */ }
					})

					// Sync to the server in the background for cross-device persistence.
					brokerClass.setTheme(next === 'dark' ? 'Dark' : 'Light').catch(() => { })
				});
				// button3.textContent = 'Change Theme';
				button3.appendChild(getChangeTheamIcon())
				button3.style.pointerEvents = 'all'


				var button5 = tvWidgetChart.createButton();
				button5.setAttribute('title', 'Basket Order');
				button5.setAttribute('id', 'basket_order')
				button5.addEventListener('click', function () {
					OpenBasketModel()
				});
				button5.appendChild(getBasketIcon())
				button5.style.pointerEvents = 'all'


				var button5 = tvWidgetChart.createButton();
				button5.setAttribute('title', 'Strategy');
				button5.setAttribute('id', 'strategy')
				button5.addEventListener('click', function () {
					OpenOptionStrategy()
				});
				button5.appendChild(getOptionStrategyIcon())
				button5.style.pointerEvents = 'all'

				var button5 = tvWidgetChart.createButton();
				button5.setAttribute('title', 'Feedback');
				button5.setAttribute('id', 'feedback')
				button5.addEventListener('click', function () {
					openFeedbackForm()
				});
				button5.appendChild(getFeedbackIcon())
				button5.style.pointerEvents = 'all'

				// Adding Button For Alerts
				var button5 = tvWidgetChart.createButton();
				button5.setAttribute('title', 'Alerts');
				button5.setAttribute('id', 'alerts-create')
				button5.addEventListener('click', function () {
					openAlertsForm()
				});
				button5.appendChild(getAlertsIcon())
				button5.style.pointerEvents = 'all'

				// Depth of Market — v32 dropped the sidebar entry (see NOTE at the
				// widget construction). Uses the internal trading controller
				// (same code path as the native Shift+D hotkey); if a future
				// library drops that private API the click just no-ops and
				// Shift+D keeps working.
				var domButton = tvWidgetChart.createButton();
				domButton.setAttribute('title', 'Depth of Market (Shift+D)');
				domButton.setAttribute('id', 'dom-panel')
				domButton.textContent = 'DOM';
				domButton.addEventListener('click', () => {
					try {
						const host = this.brokerClass && this.brokerClass._host;
						const trading = host && host._trading;
						if (trading && typeof trading.setDOMPanelVisibility === 'function') {
							const vis = host.domPanelVisibility && host.domPanelVisibility();
							trading.setDOMPanelVisibility(!(vis && vis.value()));
						}
					} catch (e) { /* best-effort — Shift+D is the native fallback */ }
				});
				domButton.style.pointerEvents = 'all'
				domButton.style.cursor = 'pointer'

				var button4 = tvWidgetChart.createButton();
				button4.setAttribute('title', 'Logout');
				button4.setAttribute('id', 'logout')
				button4.addEventListener('click', function () {
					deleteLocalWatchlists();
					clearSessionStorage(t('keys.orderMarginSessionKey')) // will remove if from session on logout
					logout_function('LogOutApp')
					// datafeed.closeFeed()
				});
				// button4.textContent = 'Logout';
				button4.appendChild(getLogOutIcon())
				button4.style.pointerEvents = 'all'

				// Hide separator next to logo
				const parentGroup = button0.closest('[class^="group-"]');
				if (parentGroup) {
					const next = parentGroup.nextElementSibling;
					if (next && /separatorWrap-/.test(next.className)) {
						next.style.display = 'none';
					}
				}
			});

			tvWidgetChart.watchList().then((watchlistApi) => {
				var chartWatchlist = new ChartWatchlists(watchlistApi)
				this.brokerClass.watchlists()
					.then((watchlists) => {
						watchlists.forEach((watchlist, i) => {
							chartWatchlist.addWatchlist(watchlist)
						})
					})

				function updateWatchlist(listId, name, name2) {
					chartWatchlist.updateWatchlist(listId)
				}
				function renameWatchList(listId, oldName, newName) {
					analytics.elementInteraction({ flow: tp.Flow.WATCHLIST, screen: tp.Screen.CHART, element: tp.Element.RENAME_WATCHLIST, action: tp.Action.TAPPED })
					chartWatchlist.renameWatchlist(listId, oldName, newName)
				}
				function createWatchlist(listId, name, symbols) {
					analytics.elementInteraction({ flow: tp.Flow.WATCHLIST, screen: tp.Screen.CHART, element: tp.Element.CREATE_WATCHLIST, action: tp.Action.TAPPED })
					chartWatchlist.createWatchlist(listId, name, symbols)
				}
				function deleteWatchlist(listId) {
					analytics.elementInteraction({ flow: tp.Flow.WATCHLIST, screen: tp.Screen.CHART, element: tp.Element.DELETE_WATCHLIST, action: tp.Action.TAPPED })
					chartWatchlist.deleteWatchlist(listId)
				}
				watchlistApi.onListChanged().subscribe(null, updateWatchlist, false)
				watchlistApi.onListRenamed().subscribe(null, renameWatchList, false)
				watchlistApi.onListAdded().subscribe(null, createWatchlist, false)
				watchlistApi.onListRemoved().subscribe(null, deleteWatchlist, false)
			})

			// tvWidget.onContextMenu(function(unixtime, price) {
			// 	return [ {
			// 		position: "bottom",
			// 		text: "Option Chain",
			// 		click: ()  => {
			// 			openMenuCallBack(tvWidget.activeChart().symbol())
			// 		}
			// 	}];
			// })
			tvWidgetChart.onContextMenu(function (unixtime, price) {
				return [{
					position: "top",
					text: "Option Chain",
					click: () => {
						callNewOptionChain(tvWidgetChart.activeChart().symbol())
					}
				}];
			})
			// tvWidgetChart.onContextMenu(function(unixtime, price) {
			// 	return [ {
			// 		position: "top",
			// 		text: "Create GGT",
			// 		click: ()  => {
			// 			callNewGGT(tvWidgetChart.activeChart().symbol())
			// 		}
			// 	}];
			// })
			tvWidgetChart.onContextMenu(function (unixtime, price) {
				return [{
					position: "top",
					text: "Futures Chain",
					click: () => {
						callFutureChain(tvWidgetChart.activeChart().symbol())
					}
				}];
			})
			setTimeout(() => {
				var symbol = sessionStorage.getItem("new_symbol")
				if (symbol) {
					// Warm the CAS session before the switch, so the bounded wait inside
					// resolveSymbol is usually already satisfied.
					try { this.datafeed.prewarmSession(symbol); } catch (e) { }
					tvWidgetChart.setSymbol(symbol, "1D");
					sessionStorage.removeItem("new_symbol")
				}
			}, 500);
		});

		this.SetLayoutSub();
	}

	SetLayoutSub = () => {
		this.lsubscription = layoutSubServices.getSub().subscribe(values => {
			if (values !== null) this.changeLayout(values)
		})
	}

	setNewSymbol(index, symbol) {
		// Warm the CAS session now rather than at setSymbol time — this path already
		// waits a second, which is more than enough for the fetch to land, so the
		// resolve it triggers finds the session cached and pays nothing for it.
		try { this.datafeed.prewarmSession(symbol); } catch (e) { }
		setTimeout(() => {
			this.tvWidget.chart(index).setSymbol(symbol)
		}, 1000);
	}

	changeLayout(values) {
		// console.log(values)
		const chartcount = this.tvWidget.chartsCount();
		const currentLayout = this.tvWidget.layout();


		if (chartcount === 1) {
			this.tvWidget.setLayout('2h')
			this.setNewSymbol(1, values.buySellSymbol)
		}

		if (chartcount === 2) {
			if (currentLayout === '2h') {
				this.tvWidget.setLayout('3h')
			} else {
				this.tvWidget.setLayout('3v')
			}
			this.setNewSymbol(2, values.buySellSymbol)
		}

		if (chartcount === 3) {
			if (currentLayout === '3h') {
				this.tvWidget.setLayout('4h')
			} else if (currentLayout === '3v') {
				this.tvWidget.setLayout('4v')
			} else if ((currentLayout === '2-1') || (currentLayout === '1-2')) {
				this.tvWidget.setLayout('2-2')
			} else {
				this.tvWidget.setLayout('4')
			}
			this.setNewSymbol(3, values.buySellSymbol)
		}

		if (chartcount === 4) {
			if ((currentLayout === '4h') || (currentLayout === '4v') || (currentLayout === '4') || (currentLayout === '4s') || (currentLayout === '2-2')) {
				this.tvWidget.setLayout('5s')
			} else if (currentLayout === '1-3') {
				this.tvWidget.setLayout('1-4')
			} else {
				this.tvWidget.setLayout('5s')
			}
			this.setNewSymbol(4, values.buySellSymbol)
		}

		if (chartcount === 5) {
			if (currentLayout === '5s') {
				this.tvWidget.setLayout('6c')
			} else {
				this.tvWidget.setLayout('6c')
			}
			this.setNewSymbol(5, values.buySellSymbol)
		}

		if (chartcount === 6) {
			if (currentLayout === '6c') {
				this.tvWidget.setLayout('8c')
			} else {
				this.tvWidget.setLayout('8c')
			}
			this.setNewSymbol(6, values.buySellSymbol)
		}

		if (chartcount === 7) {
			if (currentLayout === '6c') {
				this.tvWidget.setLayout('8c')
			} else {
				this.tvWidget.setLayout('8c')
			}
			this.setNewSymbol(7, values.buySellSymbol)
		}

		if (chartcount === 8) {
			if (currentLayout === '8c') {
				this.tvWidget.setLayout('8c')
			} else {
				this.tvWidget.setLayout('8c')
			}
			this.setNewSymbol(7, values.buySellSymbol)
		}


		// this.tvWidget.activeChart().setSymbol(values.buySellSymbol)

	}


	componentWillUnmount() {
		// Drop the layout subscriptions before the widget goes away, so their
		// handlers can't fire against a removed widget.
		try { this.teardownLayoutHandling?.(); } catch (e) { /* best-effort */ }
		this.teardownLayoutHandling = null;
		// A chart torn down before it became ready is not a stuck chart, and under
		// StrictMode's double-mount a leaked timer would report a phantom failure.
		try { this.chartBootWatchdog?.dispose(); } catch (e) { /* best-effort */ }
		this.chartBootWatchdog = null;
		// Same reason as the layout subscriptions above: three widget
		// subscriptions and possibly a pending sweep, which must not call back
		// into a datafeed that is going away. Under StrictMode's double-mount,
		// leaving them attached would also double every sweep.
		try { this.oiWatcher?.stop(); } catch (e) { /* best-effort */ }
		this.oiWatcher = null;
		if (window.__chartBootWatchdog) { delete window.__chartBootWatchdog; }
		// Before tvWidget.remove(): the overlay holds a canvas, a tooltip and
		// two listeners inside the library's iframe. Removing the widget tears
		// that iframe down, so disposing afterwards would be a no-op that
		// leaves the overlay's own timer running for the life of the page.
		try {
			IndicatorPack?.dispose();
		} catch (e) { /* nothing to clean up */ }
		if (this.tvWidget !== null) {
			this.tvWidget.remove();
			this.tvWidget = null;
		}
		if (this.datafeed != null) {
			this.datafeed.closeFeed();
		}
		if (this.brokerClass != null) {
			this.brokerClass.socket_disconnect()
		}
		this.lsubscription?.unsubscribe();
	}



	render() {
		return (
			<div
				ref={this.ref}
				className={'TVChartContainer'}
			/>
		);
	}
}

//make tv widget available to option chain
// tvWidget.activeChart.setSymbol(symbol)
